export type MocPriority = "HIGH" | "MEDIUM" | "LOW";

export type MocKpiAccent = "default" | "orange" | "green";

export interface MocKpi {
  id: string;
  label: string;
  value: string;
  accent: MocKpiAccent;
}

export interface MocRow {
  id: string;
  mocId: string;
  title: string;
  asset: string;
  owner: string;
  stage: string;
  workflowStage: string;
  priority: MocPriority;
  finImpact: string;
  schImpact: string;
  lastUpdated: string;
  highlighted?: boolean;
}

export const MOC_TABLE_COLUMNS = [
  "MOC ID",
  "Title",
  "Asset",
  "Owner",
  "Workflow Stage",
  "Priority",
  "Fin Impact",
  "Sch Impact",
  "Last Updated",
  "Action"
];
